import React from 'react'
import Logo from '../Images/kpn-logo.png';
import { BsFacebook, BsWhatsapp, BsInstagram } from "react-icons/bs";

export const Footer = () => {
  return (
    <div className='footer'>
        <div className="foot-content">

            <div className='footer-logo'>
            <img src={Logo} alt='logo' />
            </div>

            <div className='footer-line'>
                <h3>Contact Us</h3>
                <div>
                    <p>Phone: 1800-571-4777</p>
                    <p>Email - info@kovaipazhamudir.com</p>
                    <p>Address - NO.107, Chettiyar Agaram Road, Noombal Village</p>
                    <p> Vanagaram Chennai - 600077</p>
                </div>
            </div>

            <div className='footer-line'>
                <h3>Quick Links</h3>
                <div>
                    <p> Branches</p>
                    <p> Contact Us</p>
                    <p> Terms & Conditions</p>
                    <p> Connect with us</p>
                </div>
                <h3 className='social-head'>Connect with us</h3>
                <div className='social-icons'>
                    <i><BsFacebook /></i>
                    <i><BsWhatsapp /></i>
                    <i><BsInstagram /></i>

                </div>
            </div>


            <div className='map'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31366.68721499846!2d76.9809933237327!3d10.669842364347534!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8382a533b61cb%3A0x24fc343e1c8aa7fd!2sPollachi%20Pazhamudir%20Nilayam!5e0!3m2!1sen!2sin!4v1698767901855!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>


        </div>

        <div className='copyright'>
            <div><p>Copyright © 2021. All Rights Reserved.</p></div>
            <div><p>Designed By Mathan using React</p></div>
        </div>
    </div>
  )
}
